import Modifier from 'ember-modifier';

class ScrollToTopModifier extends Modifier {
  modify(element) {
    (document.querySelector('#main') ?? element).scrollTop = 0;
  }
}

export default ScrollToTopModifier;
